<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.detailsInfo }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.details }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naziv</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="title"
                      />
                      <form-error
                        :model="$v.title"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.topBrandItems.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Brendovi
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div>
                        <treeselect
                          v-model="topBrandItems"
                          :multiple="true"
                          :options="brands"
                          :show-count="true"
                          placeholder="Izaberite brend"
                        />
                        <form-error
                          :model="$v.topBrandItems"
                          :dirty="$v.$dirty"
                          label="Brendovi"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Boja</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <v-swatches
                            v-model="backgroundColor"
                            show-fallback
                            fallback-input-type="color"
                            show-border
                            popover-x="left"
                          >
                            <input
                              slot="trigger"
                              v-model="backgroundColor"
                              class="form-control form-control-modern w-100"
                            />
                          </v-swatches>
                        </div>

                        <div class="flex-grow-0 px-2">
                          <v-swatches
                            v-model="backgroundColor"
                            show-border
                            show-fallback
                            fallback-input-type="color"
                          ></v-swatches>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Dostupno na</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="topBrandContentType"
                      >
                        <option
                          v-for="item in b2borb2cOptions"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Zadana lista?
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <toggle-button :width="65" :height="35" color="#47a447" v-model="currentlyHighlighted"/>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div
          class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
        >
          <router-link
            exact
            :to="{ name: 'TopBrands' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import VSwatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.css';

import { ToggleButton } from 'vue-js-toggle-button';

import { translations } from '@/mixins';
import api from '@/services/api';
import validations from './validation-schema/add';
import FormError from '../../shared/form-errors/FormError.vue';

export default {
  name: 'AddTopBrandList',
  mixins: [translations],
  validations,
  components: {
    ToggleButton,
    Treeselect,
    VSwatches,
    FormError,
  },
  data() {
    return {
      topBrandContentType: 3,
      currentlyHighlighted: false,
      b2borb2cOptions: [
        {
          id: 1,
          text: 'B2B',
        },
        {
          id: 2,
          text: 'B2C',
        },
        {
          id: 3,
          text: 'Sve',
        },
      ],
      title: '',
      topBrandItems: null,
      backgroundColor: '',
    };
  },
  computed: {
    brands() {
      return this.$store.getters.getBrands.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        return;
      }

      const { title, topBrandItems, backgroundColor, topBrandContentType, currentlyHighlighted } = this;

      const payload = {
        title,
        topBrandItems,
        backgroundColour: backgroundColor,
        topBrandContentType,
        currentlyHighlighted,
      };

      api
        .createTopBrandList(payload)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'TopBrands' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
  mounted() {
    this.$store.dispatch('getBrands', {
      retrieveAll: true,
      sortBy: 'title',
      isSortAscending: true,
    });
  },
};
</script>

<style lang="scss">
.vue-swatches {
  display: block;
}

.vue-swatches__trigger__wrapper {
  display: block;
}
</style>
